var _use, _use2, _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolumeOn(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    viewBox: "0 0 36 36",
    width: "100%",
    fill: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _use || (_use = /*#__PURE__*/React.createElement("use", {
    className: "ytp-svg-shadow",
    xlinkHref: "#ytp-id-14"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    className: "ytp-svg-shadow",
    xlinkHref: "#ytp-id-15"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ytp-svg-volume-animation-mask"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m 14.35,-0.14 -5.86,5.86 20.73,20.78 5.86,-5.91 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 7.07,6.87 -1.11,15.33 19.61,36.11 27.80,27.60 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ytp-svg-volume-animation-mover",
    d: "M 9.09,5.20 6.47,7.88 26.82,28.77 29.66,25.99 z",
    transform: "translate(0, 0)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ytp-svg-volume-animation-slash-mask"
  }, /*#__PURE__*/React.createElement("path", {
    className: "ytp-svg-volume-animation-mover",
    d: "m -11.45,-15.55 -4.44,4.51 20.45,20.94 4.55,-4.66 z",
    transform: "translate(0, 0)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "ytp-svg-fill ytp-svg-volume-animation-speaker",
    clipPath: "url(#ytp-svg-volume-animation-mask)",
    d: "M8,21 L12,21 L17,26 L17,10 L12,15 L8,15 L8,21 Z M19,14 L19,22 C20.48,21.32 21.5,19.77 21.5,18 C21.5,16.26 20.48,14.74 19,14 ZM19,11.29 C21.89,12.15 24,14.83 24,18 C24,21.17 21.89,23.85 19,24.71 L19,26.77 C23.01,25.86 26,22.28 26,18 C26,13.72 23.01,10.14 19,9.23 L19,11.29 Z",
    fill: "#fff",
    id: "ytp-id-14"
  })), /*#__PURE__*/React.createElement("path", {
    className: "ytp-svg-fill ytp-svg-volume-animation-hider",
    clipPath: "url(#ytp-svg-volume-animation-slash-mask)",
    d: "M 9.25,9 7.98,10.27 24.71,27 l 1.27,-1.27 Z",
    fill: "#fff",
    id: "ytp-id-15",
    style: {
      display: "none"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeOn);
export default __webpack_public_path__ + "static/media/volume_on.3f7237afa5d601f6cfd24727910c26f7.svg";
export { ForwardRef as ReactComponent };